export enum NotificationDeliveryTypeEnum {
  Email = 'Email',
  SMS = 'SMS',
  Voice = 'Voice',
  Push = 'Push',
}
